import React, { useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Layout } from "antd";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import StatusConfirmation from "./StatusConfirmation";
import EntityWrapper from "../../../components/crm/style/EntityWrapper.style";
import Stages from "../../../components/crm/components/Stages";
import Activity from "../../../components/crm/components/activity/Activity";
import ContactDetails from "../../../components/crm/components/ContactDetails";
import EntityActions from "../../../components/crm/components/entityActions";
import Checklist from "../../../components/crm/components/Checklist";
import Files from "../../../components/crm/components/files/index";
import Feed from "../../../components/crm/components/feed/Feed";
import Contacts from "../../../components/crm/components/contacts/index";

import { updateOpportunityStatus } from "../../patientDetails/patientDetailsSlice";
import { usePatient_opportunity_statuses } from "../../../hooks";
import useStatus from "../hooks/useStatus";
import ConvertOrCreateWizard from "./ConvertOrCreateWizard";

const { Sider, Content } = Layout;

const FollowUp = (props) => {
  const { hasAssetsPermission } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1450px)",
  });
  const [convertVisible, setConvertVisible] = useState(false);
  const [feedReloadTimestamp, setFeedReloadTimestamp] = useState(false);
  const patient_opportunity_statuses = usePatient_opportunity_statuses();
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const { stagesValue, stages } = useStatus(
    patient_opportunity_statuses,
    activePatient
  );

  const onConvert = () => {
    setConvertVisible(true);
  };

  const hideConvertWizard = () => {
    setConvertVisible(false);
  };

  const onChangeStatus = async (val) => {
    if (val === 0) {
      //irrelevant status
      confirm(val);
    } else if (val < 4) {
      commitOpportunityStatus(val);
    } else {
      onConvert();
      //active patient status
    }
  };

  const commitOpportunityStatus = async (val, fromConfirm) => {
    const status = patient_opportunity_statuses.find(
      (i) => i.sort_order === val + 1
    );
    const action = await dispatch(
      updateOpportunityStatus({
        patient: { id: activePatient.id, opportunity_status_id: status.id },
        branchId: activePatient.branch_id,
        fromCrm: true,
      })
    );
    if (!action.error && fromConfirm) {
      const isAdmin = location.pathname.includes("admin");
      const url = isAdmin
        ? `../../../admin/crm_patients`
        : `../../../branches/${activePatient.branch_id}/crm_patients`;
      history.push(url);
    }
  };

  const { confirm, contextHolder } = StatusConfirmation(
    commitOpportunityStatus
  );

  const onReloadFeed = () => {
    setFeedReloadTimestamp(moment().format());
  };

  return (
    <>
      {contextHolder}
      <EntityWrapper hasTabs={true}>
        <Layout>
          <Sider
            width="350px"
            style={{ background: "transparent" }}
            className="fixed-position"
          >
            <EntityActions
              type={"opportunity"}
              onConvert={onConvert}
              record={activePatient}
            />
            <ContactDetails record={activePatient} />
            {hasAssetsPermission && (
              <Files
                resource="crm/patients"
                branchId={activePatient.branch_id}
              />
            )}
          </Sider>
          <Content className="entity-content">
            {isDesktopOrLaptop && (
              <Stages
                onChangeStatus={onChangeStatus}
                items={stages}
                value={stagesValue}
                direction="horizontal"
              />
            )}

            <Activity
              entity={"crm/patients"}
              entityId={activePatient.id}
              branchId={activePatient.branch_id}
              onReloadFeed={onReloadFeed}
            />
            <Feed
              entity={"crm/patients"}
              entityId={activePatient.id}
              branchId={activePatient.branch_id}
              onReloadFeed={onReloadFeed}
              feedReloadTimestamp={feedReloadTimestamp}
            />
          </Content>
          <Sider
            width="300px"
            style={{ background: "transparent" }}
            className="fixed-position"
          >
            {!isDesktopOrLaptop && (
              <Stages
                onChangeStatus={onChangeStatus}
                items={stages}
                value={stagesValue}
                direction="vertical"
              />
            )}

            <Contacts contacts={activePatient.relatives} />
            <Checklist record={activePatient} />
          </Sider>
        </Layout>
      </EntityWrapper>

      <ConvertOrCreateWizard
        visible={convertVisible}
        hide={hideConvertWizard}
        type="convert"
        fromCrm={true}
      />
    </>
  );
};

export default memo(FollowUp);
